module.exports = __webpack_public_path__ + "static/img/login-bg.6a79192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login-bg.jpg
// module id = VKqO
// module chunks = 1